import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es físico o digital?',
  a: '100% digital en PDF. Lo recibís por email en menos de 5 minutos.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Arrancás desde cero absoluto con el Módulo 1.'
}, {
  q: '¿Cuándo lo recibo?',
  a: 'Inmediatamente después del pago. Revisá Spam si no aparece.'
}, {
  q: '¿Qué herramientas necesito?',
  a: 'El Bono 3 tiene la guía completa de herramientas mínimas para arrancar.'
}, {
  q: '¿Sirve para automotor?',
  a: 'Sí. El Módulo 5 y el Bono Automotor cubren todo ese nicho.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <h2 className="text-4xl font-black text-center text-brand-dark mb-12" data-id="element-74">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-75">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-100 rounded-xl overflow-hidden shadow-sm" data-id="element-76">
              <button className="w-full px-6 py-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-77">
                <span className="font-bold text-lg text-brand-dark pr-4" data-id="element-78">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-primary flex-shrink-0" data-id="element-79" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-80" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-white text-gray-700 text-lg leading-relaxed border-t border-gray-100" data-id="element-81">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}